import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'viewSelection.title',
    defaultMessage: 'Saved views',
    description: 'Title of the view selection drawer',
  },
  actions: {
    setAsDefault: {
      id: 'viewSelection.actions.setAsDefault',
      defaultMessage: 'Set as default',
      description: 'Label of the set as default action',
    },
  },
  confirmDeleteView: {
    title: {
      id: 'viewSelection.confirmDeleteView.title',
      defaultMessage: 'Delete view',
      description: 'Title of the confirm delete view dialog',
    },
    description: {
      id: 'viewSelection.confirmDeleteView.description',
      defaultMessage: 'Are you sure you would like to delete this view?',
      description: 'Description of the confirm delete view dialog',
    },
    buttons: {
      cancel: {
        id: 'viewSelection.confirmDeleteView.buttons.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel action of the confirm delete view dialog',
      },
      delete: {
        id: 'viewSelection.confirmDeleteView.buttons.delete',
        defaultMessage: 'Delete',
        description: 'Label of the delete action of the confirm delete view dialog',
      },
    },
  },
};

export default defineMessages(translations);
